import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { LoaderSkeleton } from '@utilities';

import Options from '../../../Options';

import styles from './_index.module.scss';

const AttributeOptionsResults = ({
  activeAnswers,
  activePrompt,
  documentId,
  hasActivePromptLimit,
  isLoading,
  isSurvey,
  onSelectAnswer,
  pinnedAnswers,
  results,
  setPinnedAnswers,
}) => {
  const attributes = useMemo(
    () =>
      activePrompt?.attributes?.map((attribute) => {
        const data = results?.filter((result) => result?.attributeId === attribute?.id);
        return { data, id: attribute?.id, name: attribute?.name };
      }),
    [results]
  );
  if (isLoading)
    return (
      <LoaderSkeleton height={115}>
        <rect height="15" rx="2" ry="2" width="200" x="0" y="0" />
        <rect height="15" rx="2" ry="2" width="175" x="0" y="25" />
        <rect height="15" rx="2" ry="2" width="225" x="0" y="50" />
        <rect height="15" rx="2" ry="2" width="200" x="0" y="75" />
        <rect height="15" rx="2" ry="2" width="225" x="0" y="100" />
      </LoaderSkeleton>
    );

  if (attributes && attributes?.some((attribute) => attribute?.data?.length > 0)) {
    return attributes?.map((attribute, index) => {
      if (attribute?.data?.length === 0) return null;

      return (
        <div className={styles['attribute-options-results']} key={`attribute-result-${index}`}>
          <span className={styles['attribute-options-results-left-column']}>{attribute?.name}</span>
          <div className={styles['attribute-options-results-right-column']}>
            <Options
              activeAnswers={activeAnswers}
              activePrompt={activePrompt}
              documentId={documentId}
              hasActivePromptLimit={hasActivePromptLimit}
              isSurvey={isSurvey}
              max={activePrompt?.max}
              onSelectAnswer={onSelectAnswer}
              options={attribute?.data}
              pinnedAnswers={pinnedAnswers}
              setPinnedAnswers={setPinnedAnswers}
            />
          </div>
        </div>
      );
    });
  }

  return <div>No results found.</div>;
};

AttributeOptionsResults.propTypes = {
  activeAnswers: PropTypes.array,
  activePrompt: PropTypes.object,
  documentId: PropTypes.string,
  hasActivePromptLimit: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSurvey: PropTypes.bool,
  onSelectAnswer: PropTypes.func,
  pinnedAnswers: PropTypes.object,
  results: PropTypes.array,
  setPinnedAnswers: PropTypes.func,
};

export default AttributeOptionsResults;
